import React from "react";

function ModalSimple(props) {
  const modalSide = props.left ? { left: 0 } : {}
  const combinedStyle = { zIndex: 101, ...modalSide, ...props.style };

  return (
    <div className={"modal-wrapper"}>
      <div className={"modal-backdrop"} />
      <div className="modal-dialog modal-edit" style={combinedStyle}>
        <ModalContent text={props.text} children={props.children} hide={props.hide} secondButton={props.secondButton} secondButtonText={props.secondButtonText} onClose={props.onClose} />
      </div>
    </div>
  );
}

ModalSimple.defaultProps = {
  style: {},
};

export default ModalSimple;


export const ModalContent = ({ text, children, hide, secondButton, secondButtonText, onClose }) => {
  return (
    <div className="modal-content" style={{ height: "100vh" }}>
      <div className="modal-header pb-0" style={{
        borderBottom: "none"
      }}>
        <h5 className="text-xl font-bold">{text}</h5>
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={() => onClose()}
        >
          <span aria-hidden="true" style={{
            color: "#00000080"
          }}>&times;</span>
        </button>
      </div>
      <div
        className="modal-body"
        style={{ height: "100vh", overflow: "auto" }}
      >
        {children}
      </div>
      {hide !== true && (
        <div className="modal-footer">
          {secondButton && (
            <button
              type="button"
              className="btn btn-primary btn-block"
              onClick={() => secondButton()}
            >
              {secondButtonText}
            </button>
          )}
          <button
            type="button"
            className={"btn btn-outline-dark btn-block"}
            onClick={() => onClose()}
          >
            Close
          </button>
        </div>
      )}
    </div>
  )
}